import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ArrowLeftIcon = (props: SvgIconProps) => (
  <SvgIcon width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3237 4.42472C18.7793 4.88033 18.7793 5.61902 18.3237 6.07463L10.3986 13.9997L18.3237 21.9247C18.7793 22.3803 18.7793 23.119 18.3237 23.5746C17.868 24.0302 17.1293 24.0302 16.6737 23.5746L7.92374 14.8246C7.46813 14.369 7.46813 13.6303 7.92374 13.1747L16.6737 4.42472C17.1293 3.9691 17.868 3.9691 18.3237 4.42472Z"
      fill="white"
    />
  </SvgIcon>
);
